import { versionCheck } from '@mssgme/shared';
import { useWorkspace } from './useWorkspace';

export function useExperiments() {
    const { card, projectVersion } = useWorkspace();
    const isLinksDisplayed = !!card?.links?.length;
    const isInboxDisplayed = versionCheck(projectVersion, '<=2.9');
    const isOldVersionDisplayed = process.env.REACT_APP_TARGET !== 'mobile' && versionCheck(projectVersion, '<4.0.0');
    const isSavingUtm = versionCheck(projectVersion, '>=5.12.0');

    return {
        isInboxDisplayed,
        isLinksDisplayed,
        isSavingUtm,
        isOldVersionDisplayed,
    };
}
